export default {
  props: {
    title: {
      type: String,
      required: true,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    }
  }
};